//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React from "react";
// All pages that rely on 3rd party components (other than Bootstrap) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AdminLayout from "./layouts/Admin";

//Clients
import ClientsProfile from "./clients/manageClients/clientProfile";
import ManageClients from "./clients/manageClients/manageClients";
import EditExistingClients from "./clients/manageClients/editExistingClient";

//Generic Accounts
import ViewGenericAccount from "./genericAccounts/viewGenericAccounts/viewGA";
import AddManageGenericAccount from "./genericAccounts/addManageGenericAccounts/addManageGA";
import GenericAccountDetails from "./genericAccounts/genericAccountDetailScreen/accountDetailsScreen";
// Landing

import AdminMenu from "./adminPages/adminMenu";
import Candidates from "./candidates";
import CandidateProfile from "./candidate/ProfileDetails";

//Users
import UserAccounts from "./users/userAccount";
import CreateNewUser from "./users/createNewUser";
import UserDetails from "./users/userDetails";


// Forms
import Layouts from "./pages/forms/Layouts";
import BasicInputs from "./pages/forms/BasicInputs";
import InputGroups from "./pages/forms/InputGroups";
import FloatingLabels from "./pages/forms/FloatingLabels";
import AdvancedInputs from "./pages/forms/AdvancedInputs";
import Formik from "./pages/forms/Formik";
import Editors from "./pages/forms/Editors";


//System Messages
import SystemMessage from './systemMessages/message';
import EditSystemMessage from "./systemMessages/editSystemMessage";
import SearchSystemMessage from "./systemMessages/searchSystemMessage";
import Page404 from "./pages/auth/Page404";


const routes = [
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <AdminMenu />,
      },
    ],
  },
  {
    path: "dashBoard",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <AdminMenu />,
      },
    ],
  },
  {
    path: "",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <ViewGenericAccount />,
      },
    ],
  },
  {
    path: "generic-accounts-details",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <GenericAccountDetails />,
      },
    ],
  },
  {
    path: "user-details",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <UserDetails />,
      },
    ],
  },
  {
    path: "candidates",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <Candidates />,
      },
    ],
  },
  {
    path: "candidateProfile",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <CandidateProfile />,
      },
    ],
  },
  {
    path: "add-manage-generic-accounts",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <AddManageGenericAccount />,
      },
    ],
  },
  {
    path: "clients",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <ManageClients />,
      },
    ],
  },
  {
    path: "clients-profile",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <ClientsProfile />,
      },
    ],
  },
  {
    path: "edit-existing-clients",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <EditExistingClients />,
      },
    ],
  },
  {
    path: "users",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <UserAccounts />,
      },
    ],
  },
  {
    path: "createNewUser",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <CreateNewUser />,
      },
    ],
  },
  {
    path: "*",
    element: <Page404 />,
    children: [
      {
        path: "",
        element: <Page404 />,
      },
    ],
  },
  {
    path: "systemMessage",
    element: <AdminLayout />,
    children: [
      {
        path: "",
        element: <SystemMessage />,
      },
      {
        path: "search",
        element: <SearchSystemMessage />,
      },
      {
        path: "edit",
        element: <EditSystemMessage />,
      },
    ],
  }
];

export default routes;
